export default __webpack_public_path__ + "static/media/office-desk.6691d2ff.svg";